<template>
  <li
    class="tw-relative tw-my-0.5 tw-flex tw-h-auto tw-w-full tw-items-center tw-justify-start tw-bg-white"
  >
    <a
      :href="props.link"
      :data-test-id="props.dataTestId"
      target="_blank"
      class="tw-inline-flex tw-h-full tw-w-full tw-rounded tw-bg-white tw-px-2 tw-py-4 tw-no-underline tw-transition-colors hover:tw-bg-dorian-gray-50/40 dark:hover:tw-bg-dorian-gray-100/60"
      :class="{
        'tw-pointer-events-none tw-border tw-border-secondary-500 tw-bg-secondary-50':
          props.active,
      }"
    >
      <figure
        class="tw-relative tw-flex tw-h-full tw-w-full tw-items-center tw-justify-between"
      >
        <slot></slot>
        <figcaption class="tw-text-lg tw-font-bold tw-text-dorian-gray-500">
          {{ props.label }}
          <cl-icon-tabler-circle-check-filled v-if="props.active" />
        </figcaption>
      </figure>
    </a>
  </li>
</template>

<script lang="ts" setup>
import { ClIconTablerCircleCheckFilled } from "../icons/cl-icon-tabler-circle-check-filled";

export interface HeaderDropdownProductProps {
  link: string;
  active?: boolean;
  label?: string;
  dataTestId?: string;
}

const props = withDefaults(defineProps<HeaderDropdownProductProps>(), {
  label: "",
  dataTestId: "",
  active: false,
});
</script>

<style scoped></style>
